import MazeError from './MazeError'

export default MazeError
